export default {
  colors: {
    primary: `#D8DEE9`,
    background: `#2E3440`,
    shape: `#115E6A`,
    title: `#fefefe`,
    text: `#F6F6F6 `,
    components: {
      blockquote: {
        background: `#feebc8`,
        text: `#2d3748`,
      },
    },
  },
};
